import React from 'react';
import { ChevronDown, Layers, RefreshCw } from 'lucide-react';
import { desktopRibbonInputClass } from '../ribbon/DesktopRibbonControls';
import type { MapType } from '../../types/common';
import type { ProjectStatus } from '../../types/enterpriseProject';
import {
  PROJECT_STATUS_LABELS,
} from '../../types/enterpriseProject';

const STATUS_FILTER_OPTIONS: Array<{ value: ProjectStatus | ''; label: string }> = [
  { value: '', label: 'Todos os Status' },
  { value: 'draft', label: PROJECT_STATUS_LABELS.draft },
  { value: 'active', label: PROJECT_STATUS_LABELS.active },
  { value: 'on_hold', label: PROJECT_STATUS_LABELS.on_hold },
  { value: 'completed', label: PROJECT_STATUS_LABELS.completed },
  { value: 'archived', label: PROJECT_STATUS_LABELS.archived },
];

const MAP_TYPE_FILTER_OPTIONS: Array<{ value: MapType | ''; label: string }> = [
  { value: '', label: 'Todos os Tipos' },
  { value: 'FACTORY', label: 'Factory' },
  { value: 'OFFICE', label: 'Office' },
];

export interface FluxosListRibbonFiltersProps {
  filterMapType: MapType | '';
  filterStatus: ProjectStatus | '';
  onMapTypeChange: (value: MapType | '') => void;
  onStatusChange: (value: ProjectStatus | '') => void;
  onRefresh?: () => void;
  showRefresh?: boolean;
}

export const FluxosListRibbonFilters: React.FC<FluxosListRibbonFiltersProps> = ({
  filterMapType,
  filterStatus,
  onMapTypeChange,
  onStatusChange,
  onRefresh,
  showRefresh = false,
}) => (
  <div className="flex items-center gap-1.5 mr-2">
    {showRefresh && onRefresh && (
      <button
        type="button"
        onClick={onRefresh}
        className="flex h-[30px] shrink-0 items-center gap-1.5 rounded-[3px] border border-[var(--border-default)] bg-[var(--bg-surface)] px-2 text-[11px] font-medium text-[var(--text-secondary)] transition-colors hover:bg-[var(--button-hover)]"
        title="Atualizar lista"
      >
        <RefreshCw size={12} strokeWidth={1.5} />
        Atualizar
      </button>
    )}
    <div className="relative flex items-center">
      <Layers size={11} className="pointer-events-none absolute left-2 text-slate-400 z-10" />
      <select
        value={filterMapType}
        onChange={e => onMapTypeChange(e.target.value as MapType | '')}
        className={`pl-6 pr-6 w-36 appearance-none ${desktopRibbonInputClass}`}
        title="Filtrar por tipo"
      >
        {MAP_TYPE_FILTER_OPTIONS.map(o => (
          <option key={o.value || 'all'} value={o.value}>{o.label}</option>
        ))}
      </select>
      <ChevronDown size={10} className="pointer-events-none absolute right-2 text-slate-400" />
    </div>
    <div className="relative flex items-center">
      <select
        value={filterStatus}
        onChange={e => onStatusChange(e.target.value as ProjectStatus | '')}
        className={`px-2 pr-6 w-36 appearance-none ${desktopRibbonInputClass}`}
        title="Filtrar por status"
      >
        {STATUS_FILTER_OPTIONS.map(o => (
          <option key={o.value || 'all'} value={o.value}>{o.label}</option>
        ))}
      </select>
      <ChevronDown size={10} className="pointer-events-none absolute right-2 text-slate-400" />
    </div>
  </div>
);
